import { ArchiveRestoreRequestMsg, ArchiveRestoreRequestQuery } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import t from '../../i18n/I18n';
import { showSuccessMsg } from '../../store/StoreUtil';
import { createNewArchiveRestoreWebRequestMessage } from './Archive-restore-util';

export class ArchiveQuery {
  constructor(hiResStatus, midResStatus, lowResStatus, directStatus, fuidSet, storageType, location, keepSource) {
    this.hiResStatus = hiResStatus;
    this.midResStatus = midResStatus;
    this.lowResStatus = lowResStatus;
    this.directStatus = directStatus;
    this.fuidSet = fuidSet;
    this.storageType = storageType;
    this.location = location;
    this.keepSource = keepSource;
  }

  run(onRefreshPWD ?: function) {
    const query = new ArchiveRestoreRequestQuery();
    const msg: ArchiveRestoreRequestMsg = createNewArchiveRestoreWebRequestMessage(
      1,
      this.fuidSet,
      'ARCHIVE-VAB',
      this.hiResStatus,
      this.midResStatus,
      this.lowResStatus,
      this.directStatus,
      this.storageType,
      this.location,
      this.keepSource
    );
    query.message = msg;
    query.run().then(
      (resp) => {
        onRefreshPWD();
        showSuccessMsg(t('ARCHIVE_SUCCESS'));
      },
      (failedResp) => {
        ErrorHandler.handleError(failedResp);
      }
    );
  }
}
